import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import {
	appAcceptsansthaMembership,
	appDeletesansthaMembership,
	appGetAllSanstha,
	appGetSansthaById,
	appRejctedsansthaMembership,
} from '../../store/sanstha'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
// import { appAllGetHubs } from '../../store/hubs'
import { appPendingMembership } from '../../store/pendingmembers'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

export const getSubscriptionDates = (type, baseDate = new Date()) => {
	const startDate = new Date(baseDate)
	const endDate = new Date(baseDate)

	switch (type) {
		case 'Monthly':
			endDate.setMonth(endDate.getMonth() + 1)
			break
		case 'Yearly':
			endDate.setFullYear(endDate.getFullYear() + 1)
			break
		case 'Lifetime':
		default:
			endDate.setFullYear(9999, 11, 31)
			break
	}

	return {
		membershipStartDate: startDate,
		membershipEndDate: endDate,
		membershipType: type,
	}
}

const formatDateForInput = date => {
	if (!date) return ''
	const parsedDate = new Date(date)
	if (Number.isNaN(parsedDate.getTime())) return ''
	return parsedDate.toISOString().split('T')[0]
}

const getMemberName = user =>
	[user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.mobile || 'Member'

const formatMembershipDate = date => {
	if (!date) return '-'
	const parsedDate = new Date(date)
	if (Number.isNaN(parsedDate.getTime())) return '-'

	return parsedDate.toLocaleDateString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	})
}

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const [showUserModal, setShowUserModal] = useState(false)
	const [showAcceptModal, setShowAcceptModal] = useState(false)
	const [acceptMembership, setAcceptMembership] = useState(null)
	const [acceptMemberships, setAcceptMemberships] = useState([])
	const [acceptForm, setAcceptForm] = useState({
		membershipType: '',
		membershipStartDate: '',
		membershipEndDate: '',
	})
	const [acceptError, setAcceptError] = useState('')
	const [acceptLoading, setAcceptLoading] = useState(false)
	const [rejectionReason, setRejectionReason] = useState('')
	const [rejectionError, setRejectionError] = useState('')
	const [rejectedId, setRejectedId] = useState(null)
	const [page, setPage] = useState(params.page || 1)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({
		sanstha: null,
		hub: null,
		startDate: null,
		endDate: null,
	})
	const [error, setError] = useState('')
	const hub = useSelector(state => state?.hubReducer.hub)
	const sanstha = useSelector(state => state?.sansthaReducer.sanstha)
	const paginate = useSelector(state => state.PendingMembershipReducer.paginate)
	const pendingMembership = useSelector(state => state.PendingMembershipReducer.pendingMembership)

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const getPendingMembershipParams = useCallback(
		(pageNo = page) => ({
			...activeFilters,
			page: pageNo,
			limit: 10,
			hub: hubId || permissionOfHub,
		}),
		[activeFilters, hubId, page, permissionOfHub],
	)

	useEffect(() => {
		dispatch(
			appGetAllSanstha({ page: 1, limit: 1000, hub: hubId || permissionOfHub, loading: false }),
		)
		// dispatch(appAllGetHubs({ page: 1, limit: 1000 }))
	}, [page])
	useEffect(() => {
		dispatch(appPendingMembership(getPendingMembershipParams()))
		navigate(`/requsteduser/${page}`)
	}, [page, activeFilters, getPendingMembershipParams])

	const handleSearch = useCallback(() => {
		if (selectedFilters.startDate && !selectedFilters.endDate) {
			setError('Please select an end date.')
			return
		}

		setError('')
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.startDate) {
			filters.startDate = selectedFilters.startDate
		}
		if (selectedFilters.endDate) {
			filters.endDate = selectedFilters.endDate
		}
		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters])

	const handleDeletesansthaMembership = membershipId => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Sanstha Membership?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(
					appDeletesansthaMembership({
						id: membershipId,
					}),
				).then(() => {
					dispatch(
						appPendingMembership({
							page: 1,
							limit: 10,
							hub: hubId || permissionOfHub,
						}),
					)
				})
			}
		})
	}

	const handleRejectedsansthaMembership = id => {
		setRejectedId(id)
		setShowUserModal(true)
	}

	const handleAcceptedsansthaMembership = async item => {
		const sansthaId = item?.sansthaId?._id
		const membershipDates = getSubscriptionDates(
			item?.membershipType,
			item?.membershipStartDate || new Date(),
		)

		setAcceptMembership(item)
		setAcceptMemberships([])
		setAcceptError('')
		setAcceptForm({
			membershipType: item?.membershipType || '',
			membershipStartDate:
				formatDateForInput(item?.membershipStartDate) ||
				formatDateForInput(membershipDates.membershipStartDate),
			membershipEndDate:
				formatDateForInput(item?.membershipEndDate) ||
				formatDateForInput(membershipDates.membershipEndDate),
		})
		setShowAcceptModal(true)

		if (!sansthaId) return

		setAcceptLoading(true)
		const response = await dispatch(appGetSansthaById(sansthaId))
		const sansthaMemberships = response?.payload?.data?.membership || []
		setAcceptMemberships(Array.isArray(sansthaMemberships) ? sansthaMemberships : [])
		setAcceptLoading(false)
	}

	const handleAcceptTypeChange = membershipType => {
		const selectedMembership = acceptMemberships.find(
			membership => membership?.membershipType === membershipType,
		)
		const baseDate = acceptForm.membershipStartDate || new Date()
		const membershipDates = getSubscriptionDates(membershipType, baseDate)

		setAcceptForm(prev => ({
			...prev,
			membershipType,
			membershipEndDate: formatDateForInput(membershipDates.membershipEndDate),
		}))
		setAcceptMembership(prev => ({
			...prev,
			membershipType,
			amount: selectedMembership?.membershipfee ?? prev?.amount,
		}))
	}

	const handleAcceptStartDateChange = membershipStartDate => {
		const membershipDates = getSubscriptionDates(acceptForm.membershipType, membershipStartDate)

		setAcceptForm(prev => ({
			...prev,
			membershipStartDate,
			membershipEndDate: formatDateForInput(membershipDates.membershipEndDate),
		}))
	}

	const handleCloseAcceptModal = () => {
		setShowAcceptModal(false)
		setAcceptMembership(null)
		setAcceptMemberships([])
		setAcceptError('')
		setAcceptForm({
			membershipType: '',
			membershipStartDate: '',
			membershipEndDate: '',
		})
	}

	const handleSubmitAcceptMembership = () => {
		if (
			!acceptForm.membershipType ||
			!acceptForm.membershipStartDate ||
			!acceptForm.membershipEndDate
		) {
			setAcceptError('Please fill all membership details.')
			return
		}

		const selectedMembership = acceptMemberships.find(
			membership => membership?.membershipType === acceptForm.membershipType,
		)

		dispatch(
			appAcceptsansthaMembership({
				membershipId: acceptMembership?._id,
				membershipType: acceptForm.membershipType,
				membershipStartDate: acceptForm.membershipStartDate,
				membershipEndDate: acceptForm.membershipEndDate,
				amount: selectedMembership?.membershipfee ?? acceptMembership?.amount,
			}),
		).then(() => {
			dispatch(appPendingMembership(getPendingMembershipParams(1)))
		})
		handleCloseAcceptModal()
	}

	const selectedAcceptMembership = acceptMemberships.find(
		membership => membership?.membershipType === acceptForm.membershipType,
	)

	const hnadleSubmitRected = () => {
		if (!rejectionReason.trim()) {
			setRejectionError('Reason is required.')
			return
		}
		setRejectionError('')
		dispatch(
			appRejctedsansthaMembership({
				membershipId: rejectedId,
				rejectionreason: rejectionReason,
			}),
		).then(() => {
			dispatch(
				appPendingMembership({
					page: 1,
					limit: 10,
					hub: hubId || permissionOfHub,
				}),
			)
		})
		setShowUserModal(false)
		setRejectionReason('')
		setRejectedId(null)
	}

	const handleCloseModal = () => {
		setShowUserModal(false)
		setRejectionReason('')
		setRejectionError('')
		setRejectedId(null)
	}

	const isUpgradeMembership = item =>
		item?.upgradeMembership === true || item?.upgradeMembership === 'true'

	const renderMembershipType = item => {
		const appliedMembership = item?.membershipType || '-'
		const existingMembership = item?.previousMembershipType || '-'
		const appliedStartDate = formatMembershipDate(item?.membershipStartDate)
		const appliedEndDate = formatMembershipDate(item?.membershipEndDate)
		const existingStartDate = formatMembershipDate(item?.previousMembershipStartDate)
		const existingEndDate = formatMembershipDate(item?.previousMembershipEndDate)

		if (!isUpgradeMembership(item)) {
			return (
				<div
					style={{
						border: '1px solid #dbe4ee',
						borderRadius: '6px',
						padding: '8px 10px',
						backgroundColor: '#f8fafc',
						minWidth: '170px',
					}}
				>
					<div className="text-muted" style={{ fontSize: '11px', fontWeight: 600 }}>
						First Time Membership
					</div>
					<div style={{ fontWeight: 700, marginTop: '4px', color: '#1f2937' }}>
						{appliedMembership}
					</div>
					<div className="text-muted" style={{ fontSize: '12px', marginTop: '10px' }}>
						<div>
							<strong>Start:</strong> {appliedStartDate}
						</div>
						<div style={{ marginTop: '4px' }}>
							<strong>End:</strong> {appliedEndDate}
						</div>
					</div>
				</div>
			)
		}

		return (
			<div
				style={{
					border: '1px solid #dbe4ee',
					borderRadius: '6px',
					overflow: 'hidden',
					minWidth: '260px',
					backgroundColor: '#fff',
				}}
			>
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: '1fr 1fr',
						backgroundColor: '#eef2f7',
						borderBottom: '1px solid #dbe4ee',
						color: '#475569',
						fontSize: '11px',
						fontWeight: 700,
						textTransform: 'uppercase',
					}}
				>
					<div style={{ padding: '7px 10px', borderRight: '1px solid #dbe4ee' }}>
						Existing Membership
					</div>
					<div style={{ padding: '7px 10px' }}>Applied Membership</div>
				</div>
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: '1fr 1fr',
						alignItems: 'stretch',
						fontSize: '13px',
					}}
				>
					<div
						style={{
							padding: '10px',
							borderRight: '1px solid #dbe4ee',
							color: '#64748b',
							fontWeight: 600,
						}}
					>
						<div>{existingMembership}</div>
						<div style={{ fontSize: '12px', fontWeight: 500, marginTop: '12px' }}>
							<div>
								<strong>Start:</strong> {existingStartDate}
							</div>
							<div style={{ marginTop: '4px' }}>
								<strong>End:</strong> {existingEndDate}
							</div>
						</div>
					</div>
					<div
						style={{
							padding: '10px',
							backgroundColor: '#f0fdf4',
							color: '#166534',
							fontWeight: 700,
						}}
					>
						<div>{appliedMembership}</div>
						<div style={{ fontSize: '12px', fontWeight: 500, marginTop: '12px' }}>
							<div>
								<strong>Start:</strong> {appliedStartDate}
							</div>
							<div style={{ marginTop: '4px' }}>
								<strong>End:</strong> {appliedEndDate}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<>
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Sanstha</label>
								<Select
									options={
										Array.isArray(sanstha)
											? sanstha.map(sanstha => ({
													value: sanstha._id,
													label: toCamelCase(sanstha?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											sanstha: option,
										}))
									}}
									value={selectedFilters.sanstha}
									placeholder="Select Sanstha.."
									getOptionLabel={option => option?.name || option?.label}
									getOptionValue={option => option?._id || option?.value}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label>Start Date</label>
								<input
									type="date"
									className="form-control"
									value={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											startDate: value,
											endDate: prev.endDate && prev.endDate < value ? '' : prev.endDate,
										}))
									}}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>End Date</label>
								<input
									type="date"
									className="form-control"
									min={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									value={selectedFilters.endDate || ''}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											endDate: value,
										}))
										if (value) {
											setError('')
										}
									}}
								/>
								{error && <span className="text-danger">{error}</span>}
							</div>
						</div>
						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										sanstha: null,
										hub: null,
										startDate: null,
										endDate: null,
									})
									setActiveFilters({})
									setExportFilters({})
									setPage(1)
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>
					<div className="table-responsive">
						<table className="table table-bordered table-hover">
							<thead>
								<tr>
									<th>Community</th>
									<th>Sanstha</th>
									<th>User</th>
									<th data-column-id="sender">Mobile number </th>
									<th>Membership Type</th>
									<th>Honorary Answer</th>
									<th>Amount</th>
									<th data-column-id="received" data-order="desc">
										Documents
									</th>

									<th>Existing Member</th>
									<th>payment Reference No</th>
									<th>payment Date</th>
									<th data-column-id="received" data-order="desc">
										Status
									</th>

									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										Action
										<div></div>
									</th>
								</tr>
							</thead>
							{pendingMembership.data?.map(item => (
								<tbody>
									<tr>
										<td>
											<PostPreview value={item?.hub?.image} />

											{toCamelCase(item?.hub?.name)}
										</td>
										<td>
											{' '}
											<PostPreview value={item?.sansthaId?.image} />
											{toCamelCase(item?.sansthaId?.name)}
										</td>
										<td>
											<PostPreview value={item?.userId?.profilePic || '/img/user.jpg'} />
											{item?.userId?.firstName} {item?.userId?.lastName}
										</td>
										<td> {item?.userId?.mobile}</td>
										<td>{renderMembershipType(item)}</td>
										<td>{item?.honoraryAnswer}</td>
										<td>
											{' '}
											₹ <span style={{ fontWeight: 'bold' }}>{item?.amount}</span>
											<br />
											{item?.paymentMode && <small>Mode: {item?.paymentMode}</small>}
										</td>
										<PostPreview value={item?.paymentScreenshot} />

										<td>
											{(item?.existingMember === true || item?.existingMember === 'true') && (
												<span className="badge badge-primary">Yes</span>
											)}
											{(item?.existingMember === false || item?.existingMember === 'false') && (
												<span className="badge badge-primary">No</span>
											)}
										</td>
										<td>{item?.paymentRef}</td>
										<td>
											{item.paymentDate}
											{/* {" "}
                      {item.paymentDate &&
                        new Date(item.paymentDate).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })} */}
										</td>
										<td>
											{item?.status === 'Pending' && (
												<span className="badge badge-primary">Pending</span>
											)}
											{item?.status === 'Accepted' && (
												<span className="badge badge-success">Accepted</span>
											)}
											{item?.status === 'Rejected' && (
												<span className="badge badge-danger">Rejected</span>
											)}
										</td>

										<td>
											{item.status === 'Pending' ? (
												<>
													<button
														type="button"
														className="btn btn-sm btn-green command-delete ml-1 mr-1"
														data-row-id="10253"
														onClick={() => handleAcceptedsansthaMembership(item)}
													>
														<i className="fa fa-check" aria-hidden="true">
															{' '}
															Update & Accept
														</i>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														data-row-id="10253"
														onClick={() => handleRejectedsansthaMembership(item?._id)}
													>
														<i className="fa fa-ban" aria-hidden="true">
															{' '}
															Reject
														</i>
													</button>
												</>
											) : (
												<button
													type="button"
													className="btn btn-sm btn-danger command-delete"
													data-row-id="10253"
													onClick={() => handleDeletesansthaMembership(item?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											)}
										</td>
									</tr>
								</tbody>
							))}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
			{showAcceptModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						top: '50px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Update & Accept Membership</h5>
								<button type="button" className="close" onClick={handleCloseAcceptModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="d-flex align-items-center mb-3">
									<img
										src={acceptMembership?.userId?.profilePic || '/img/user.jpg'}
										alt={getMemberName(acceptMembership?.userId)}
										style={{
											width: '56px',
											height: '56px',
											borderRadius: '50%',
											objectFit: 'cover',
											marginRight: '12px',
											border: '1px solid #d9e0e7',
										}}
									/>
									<div>
										<div style={{ fontWeight: 600 }}>{getMemberName(acceptMembership?.userId)}</div>
										<div className="text-muted" style={{ fontSize: '13px' }}>
											{acceptMembership?.userId?.mobile}
										</div>
									</div>
								</div>

								<div className="form-group">
									<label>Membership Start Date</label>
									<input
										type="date"
										className="form-control"
										value={acceptForm.membershipStartDate}
										onChange={e => handleAcceptStartDateChange(e.target.value)}
									/>
								</div>
								<div className="form-group">
									<label>Membership End Date</label>
									<input
										type="date"
										className="form-control"
										value={acceptForm.membershipEndDate}
										onChange={e =>
											setAcceptForm(prev => ({
												...prev,
												membershipEndDate: e.target.value,
											}))
										}
									/>
								</div>
								<div className="form-group">
									<label>Membership</label>
									<select
										className="form-control"
										value={acceptForm.membershipType}
										onChange={e => handleAcceptTypeChange(e.target.value)}
										disabled={acceptLoading}
									>
										<option value="">
											{acceptLoading ? 'Loading Membership...' : 'Select Membership'}
										</option>
										{acceptMemberships.map(membership => (
											<option key={membership?._id} value={membership?.membershipType}>
												{membership?.membershipType}
											</option>
										))}
										{acceptForm.membershipType &&
											!acceptMemberships.some(
												membership => membership?.membershipType === acceptForm.membershipType,
											) && (
												<option value={acceptForm.membershipType}>
													{acceptForm.membershipType}
												</option>
											)}
									</select>
									<div className="mt-2" style={{ fontWeight: 600 }}>
										Fee: Rs.{' '}
										{selectedAcceptMembership?.membershipfee ?? acceptMembership?.amount ?? ''}
									</div>
								</div>
								{acceptError && <div className="text-danger">{acceptError}</div>}
							</div>
							<div className="modal-footer">
								<button
									type="button"
									className="btn btn-secondary"
									onClick={handleCloseAcceptModal}
								>
									Cancel
								</button>
								<button
									type="button"
									className="btn btn-primary"
									onClick={handleSubmitAcceptMembership}
									disabled={acceptLoading}
								>
									Update & Accept
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
			{showUserModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						top: '50px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title"> Rejection </h5>
								<button type="button" className="close" onClick={handleCloseModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="form-group">
									<label>Reason of rejection</label>
									<textarea
										className="form-control"
										name="description"
										value={rejectionReason}
										onChange={e => setRejectionReason(e.target.value)}
										rows="3"
									/>
									{rejectionError && (
										<div style={{ color: 'red', marginTop: '5px' }}>{rejectionError}</div>
									)}
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
									Cancel
								</button>
								<button type="button" className="btn btn-primary" onClick={hnadleSubmitRected}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
